import { Routes } from '@angular/router';

import { authGuard, guestGuard } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app/dashboard',
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('@features/auth/login/login-page.component').then((m) => m.LoginPageComponent),
      },
      { path: '', pathMatch: 'full', redirectTo: 'login' },
    ],
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@layout/shell/shell-layout.component').then((m) => m.ShellLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('@features/dashboard/dashboard-page.component').then(
            (m) => m.DashboardPageComponent,
          ),
      },
      {
        path: 'stores',
        loadComponent: () =>
          import('@features/stores/stores-page.component').then((m) => m.StoresPageComponent),
      },
      {
        path: 'stores/requested',
        loadComponent: () =>
          import('@features/stores/store-requested/store-requested-page.component').then(
            (m) => m.StoreRequestedPageComponent,
          ),
      },
      {
        path: 'stores/sign-user',
        loadComponent: () =>
          import('@features/stores/sign-store-users/sign-store-users-page.component').then(
            (m) => m.SignStoreUsersPageComponent,
          ),
      },
      {
        path: 'stores/not-active-users',
        loadComponent: () =>
          import('@features/stores/not-active-stores/not-active-stores-page.component').then(
            (m) => m.NotActiveStoresPageComponent,
          ),
      },
      {
        path: 'stores/orders',
        loadComponent: () =>
          import('@features/stores/store-orders/store-orders-page.component').then(
            (m) => m.StoreOrdersPageComponent,
          ),
      },
      {
        path: 'stores/:storeId',
        loadComponent: () =>
          import('@features/stores/store-details/store-details-page.component').then(
            (m) => m.StoreDetailsPageComponent,
          ),
      },
      {
        path: 'store-categories',
        loadComponent: () =>
          import('@features/store-categories/store-categories-page.component').then(
            (m) => m.StoreCategoriesPageComponent,
          ),
      },
      {
        path: 'store-complaints',
        loadComponent: () =>
          import('@features/store-complaints/store-complaints-page.component').then(
            (m) => m.StoreComplaintsPageComponent,
          ),
      },
      {
        path: 'settlements',
        loadComponent: () =>
          import('@features/settlements/settlements-page.component').then(
            (m) => m.SettlementsPageComponent,
          ),
      },
      {
        path: 'streaming/questions',
        loadComponent: () =>
          import('@features/streaming/questions/quiz-questions-page.component').then(
            (m) => m.QuizQuestionsPageComponent,
          ),
      },
      {
        path: 'streaming/questions/new',
        loadComponent: () =>
          import('@features/streaming/questions/question-form-page.component').then(
            (m) => m.QuestionFormPageComponent,
          ),
      },
      {
        path: 'streaming/questions/:questionId/edit',
        loadComponent: () =>
          import('@features/streaming/questions/question-form-page.component').then(
            (m) => m.QuestionFormPageComponent,
          ),
      },
      {
        path: 'streaming/sessions',
        loadComponent: () =>
          import('@features/streaming/sessions/stream-sessions-page.component').then(
            (m) => m.StreamSessionsPageComponent,
          ),
      },
      {
        path: 'streaming/sessions/:streamSessionId/questions',
        loadComponent: () =>
          import(
            '@features/streaming/sessions/session-questions/session-questions-page.component'
          ).then((m) => m.SessionQuestionsPageComponent),
      },
      {
        path: 'streaming/sessions/:streamSessionId/prizes',
        loadComponent: () =>
          import(
            '@features/streaming/sessions/session-prizes/session-prizes-page.component'
          ).then((m) => m.SessionPrizesPageComponent),
      },
      {
        path: 'streaming/sessions/:streamSessionId/live',
        loadComponent: () =>
          import('@features/streaming/sessions/session-live-page.component').then(
            (m) => m.SessionLivePageComponent,
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('@features/users/users-page.component').then((m) => m.UsersPageComponent),
      },
      {
        path: 'users/stores-soon',
        loadComponent: () =>
          import('@features/users/stores-soon/stores-soon-page.component').then(
            (m) => m.StoresSoonPageComponent,
          ),
      },
      {
        path: 'users/cancel-accounts',
        loadComponent: () =>
          import('@features/users/cancel-accounts/cancel-accounts-page.component').then(
            (m) => m.CancelAccountsPageComponent,
          ),
      },
      {
        path: 'users/no-account',
        loadComponent: () =>
          import('@features/users/no-account/no-account-page.component').then(
            (m) => m.NoAccountPageComponent,
          ),
      },
      {
        path: 'users/:userId',
        loadComponent: () =>
          import('@features/users/user-details/user-details-page.component').then(
            (m) => m.UserDetailsPageComponent,
          ),
      },
      {
        path: 'user-tags',
        loadComponent: () =>
          import('@features/users/user-tags/user-tags-page.component').then(
            (m) => m.UserTagsPageComponent,
          ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    ],
  },
  { path: '**', redirectTo: 'app/dashboard' },
];
